import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import Navbar from './layouts/Navbar'
import Sidebar from './layouts/Sidebar'
import AddNewCompany from './pages/add-new-company/AddNewCompany'
import AddProject from './pages/add-project/AddProject'
import CreateCompany from './pages/create-company/CreateCompany'
import CreateProject from './pages/create-project/CreateProject'
import ViewCompany from './pages/view-company/ViewCompany'
import ViewProjects from './pages/view-projects/ViewProjects'

const Admin = () => {

  const isMobileDevice = window.matchMedia('(max-width:500px)').matches
  /*const [ hasCompany , setHasCompany ] = useState(false)

  useEffect(() => {
      axios.get(`${ process.env.REACT_APP_BASE_URL }/company/all?domain=9ijakids.com`)
      .then( response => {
          if(response.data.success && response.data.data.length ){
              setHasCompany(true)
          }
      } )
  }, [])
  */

  return (
    <div>
       <Navbar />  
        <section className='md:flex justify-between mt-3'>
              {  
                  !isMobileDevice &&
                 <Sidebar className='w-[20%] h-[95vh] bg-gray-200'/> 
              }
              <div className='w-full md:w-[79%] md:h-[95vh]'>
                  <Routes>                 
                                                
                     <Route path='/create-company' 
                           element = {
                                             
                                          <CreateCompany /> 
                                       }
                        /> 

                     <Route path='/add-new-company' element = { <AddNewCompany /> } />
                     <Route path='/view-company' element = { <ViewCompany /> } />
                     <Route path='/create-project' element = { <CreateProject /> } />
                     <Route path='/add-new-project' element = { <AddProject /> } />
                     <Route path='/view-projects' element = { <ViewProjects /> } />
                  </Routes>
              </div>
        </section>
    </div>
  )
}

export default Admin